import React, {Component} from 'react';
import I18n from 'app/i18n';
import {inject, observer} from 'mobx-react';
import {ArticlesStore} from 'app/store/ArticlesStore';
import PromoNew from 'app/components/pages/articles/PromoNew';
import PromoNewBanner from 'app/components/pages/articles/PromoNewBanner';
import SmartFullPageLoader from 'app/components/reusable/smart_loaders/SmartFullPageLoader';

interface PromoNewProps {
    articlesStore?: ArticlesStore
}

@inject('articlesStore')
@observer
export default class PromoNewPage extends Component<PromoNewProps> {
    constructor(props: PromoNewProps) {
        super(props);
        props.articlesStore.refreshPromoNew();
    }

    render(): React.ReactNode {
        const {promoNewData: {loading, bets_promo, casino_promo, permanent_promo},
            activePromoNewCount, participatedPromoCount} = this.props.articlesStore;

        return loading
            ? <SmartFullPageLoader/>
            : <>
                <PromoNewBanner
                    activePromoNewCount={activePromoNewCount}
                    participatedPromoCount={participatedPromoCount}
                />
                <PromoNew
                    articles={bets_promo}
                    svgNameIcon="svg-promo-topical"
                    header={I18n.t('promo_new_header_topical')}
                />
                <PromoNew
                    articles={casino_promo}
                    svgNameIcon="svg-promo-casino"
                    header={I18n.t('promo_new_header_casino')}
                />
                <PromoNew
                    articles={permanent_promo}
                    svgNameIcon="svg-promo-permanent"
                    header={I18n.t('promo_new_header_permanent')}
                />
            </>;
    }
}
